<template>
  <div class="card shadow-sm location-card d-inline-block">
    <template v-if="isOpen === false">
      <div class="obj_isOpen">
        {{ $t("Closed") }}
      </div>
    </template>

    <div class="row no-gutters">
      <progressive-background :src="image" class="card-small-image shadow-sm" />
      <div class="col">
        <div class="card-block px-2">
          <h4 class="card-title card-small-title">{{ title }}</h4>
          <p class="location-type">
            <!-- <img
              src="@/assets/media/icons/stockholm/Home/Bed.svg"
              class="icon-hotel"
              v-if="type === 'hotel'"
              alt
            />
            <img src="@/assets/media/icons/stockholm/Cooking/Dinner.svg" class="icon-hotel" v-else alt /> -->
            <img src="@/assets/media/icons/duotone/Contacts/Clock.svg"  width="16"/>

            {{ open_time}}
           
          </p>

          <div class="">
             <div v-if="address" style="position: absolute;margin-left: 0;">
                <img src="@/assets/media/icons/duotone/Contacts/Map-Marker.svg" width="15"/> 
              </div> 
              <p class="address">
                 {{ address.substr(0, 50)}}
                 <span v-if="address.length> 50">...</span>
              </p>
          </div> 
          <div class="popup" v-if="delivery_by"> 
            <p class="delivery mt-1">
                <img src="@/assets/icon/delivery-man.svg"  width="18" alt="">
               {{ delivery_by }}</p>
               <span class="tooltiptext"> {{ $t('Delivery by')}} {{ delivery_by }}</span>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: "LocationCard",
  props: {
    image: {
      type: String,
      default: "",
    },
    title: String,
    description: String,
    address: String,
    type: String,
    isOpen: {
      type: Boolean,
      default: true,
    },
    open_times: Array,
    delivery_by: String
  },
  computed:{
    open_time(){
     
      if(!this.open_times || !this.open_times[0]) return 'Closed' 
      var is24h = this.open_times[0].is_24h
      if(is24h) return 'Alway Open'
     
      var now = moment(new Date, 'HH:mm')
      var open = []
      this.open_times.forEach(v => {
          if(v.end_time == '00:00') v.end_time = '24:00'
          var start = moment(v.start_time, 'HH:mm');
          var end = moment(v.end_time, 'HH:mm'); 
          if(start < now && end >= now && v.is_open == true){ 
             open.push(`${moment(start).format('h:mma')} - ${moment(end).format('h:mma')}`)
          }   
      });  
      if(open.length == 0) return 'Closed' 

      return open.toString()
    }
  }
};
</script>
<style lang="scss">
.delivery{
    color: #700D57;
    font-size: 10px;
    margin-left: 0;
}
.address{
  padding-top: 5px;
  font-size: 10px;
  margin-left: 20px;
}
.location-type {
  font-size: 0.7em;
  color: #59664a;
  margin-top: -10px;
}
.icon-hotel {
  max-width: 40px;
  padding-right: 7px;
}
.obj_isOpen {
    position: absolute;
    background: #dc3545;
    color: #ffffff;
    bottom: 7px;
    left: 0;
    margin-top: 0px;
    margin-bottom: 6px;
    margin-right: 6px;
    font-size: 12px;
    padding: 0px 6px;
    border-radius: 2px;
    z-index: 5;
    margin-left: 4px;
}
</style>